var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0"}},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"src":'https://kd.kyw4y0s.com/nc/saas/TF/bm/placeOrder___.html?pid=' + this.query.pid + '&eid=' + this.query.eid + '&version=' + this.query.version,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }